window.charity = {
    base: {},
    checkout: {},
    customer: {},
    order: {},
    donation: {},
    event: {},
    employee: {},
    onboarding: {}
}